import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationTypes } from 'projects/admin/src/app/models/exemptionFilling';
import { YesNoModalComponent } from 'projects/admin/src/app/shared/yes-no-modal/yes-no-modal.component';
import { forkJoin } from 'rxjs';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';

@Component({
  selector: 'app-exemption-pay-now',
  templateUrl: './exemption-pay-now.component.html',
  styleUrls: ['./exemption-pay-now.component.scss'],
})
export class ExemptionPayNowComponent implements OnInit {
  requestId: any;
  data: any;
  fisPayment: any;
  feeApplied: any;
  summary: any;
  @ViewChild('formRef')
  formRef: FormGroupDirective | undefined;
  @ViewChild('dialogRef') dialogRef: TemplateRef<any>;
  constructor(
    private dialog: MatDialog,
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private routerService: Router,
    private router: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.requestId = +atob(this.router.snapshot.params.id);
    this.feeApplied = this.summary?.amount + (this.summary?.amount * 0.0229).toFixed(2);
    // this.exemptionFilingRequestService
    //   .getPaymentDetail(this.requestId)
    //   .subscribe((res) => {
    //     console.log(res);
    //     this.data = res;
    //   });

    //   this.exemptionFilingRequestService
    //   .getSummary(this.requestId)
    //   .subscribe((payments: any) => {
    //     this.payment = payments;
    //     console.log(payments);
    //   });
    forkJoin({
      exemptionData:
        this.exemptionFilingRequestService.getExemptionFilingRequestDetail(
          this.requestId
        ),
      fis: this.exemptionFilingRequestService.getFisPaymentDetail(
        this.requestId
      ),
      sum: this.exemptionFilingRequestService.getSummary(this.requestId),
    }).subscribe(({ exemptionData, fis, sum }) => {
      this.summary = sum;
      this.data = exemptionData;
      this.fisPayment = fis;
    });
  }

  onMakePayment() {
    this.dialog.open(this.dialogRef, {
      data: {
        title: 'Payment',
        message: `You have elected to make a payment in the amount of $${this.summary?.amount} \n Is this correct?`,
      },
      disableClose: true,
    });
  }

  onBack() {
    this.exemptionFilingRequestService
      .getExemptionFilingRequestDetail(this.requestId)
      .subscribe((data) => {
        let route = '';
        let appCode = data?.exemptionRequestType?.code;
        if (
          appCode == ApplicationTypes.InitialApplication ||
          appCode == ApplicationTypes.Corrections
        ) {
          route = `/initial/${btoa(this.requestId)}`;
        } else if (
          appCode == ApplicationTypes.RenewalApplication ||
          appCode == ApplicationTypes.SubsequentApplication ||
          ApplicationTypes.ReinstatementsApplication ||
          appCode == ApplicationTypes.SubsequentRenewalApplication ||
          ApplicationTypes.SubsequentReinstatementApplication
        ) {
          route = `/renewal/${btoa(this.requestId)}`;
        }

        if (
          appCode == ApplicationTypes.RequestaCopy ||
          appCode == ApplicationTypes.VoluntaryRevocation
        ) {
          route = `/requestcopy/${btoa(this.requestId)}`;
        }
        if (appCode == ApplicationTypes.Corrections) {
          this.routerService.navigate([route], {
            queryParams: { ifpf: btoa('false'), ica: btoa('true') },
          });
        } else {
          this.routerService.navigate([route], {
            queryParams: { ifpf: btoa('false') },
          });
        }
      });
  }
}
